import React from "react";
import Accordions from "../../../components/Accordions";

const Sem8Mct = () => {
  const data = [
    {
      subjectName: "2021 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1lgks7bxGoObCf2LnzymHsn-9P7zdhI35/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2022 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1lgks7bxGoObCf2LnzymHsn-9P7zdhI35/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">MCT Sem - 8</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem8Mct;
